// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermentationProtocolId } from './FermentationProtocol';
import { fermentationParameterTypeId } from './FermentationParameterType';
import { operatorId } from './Operator';
import { fermentationLineTypeId } from './FermentationLineType';
import { z } from 'zod';
export const fermentationProtocolParameterId = (z.number());
export const fermentationProtocolParameter = z.object({
    id: fermentationProtocolParameterId,
    protocol_id: fermentationProtocolId,
    parameter_type_id: fermentationParameterTypeId,
    default_number_value: z.string().nullable(),
    default_text_value: z.string().nullable(),
    default_checkbox_value: z.boolean().nullable(),
    is_required: z.boolean(),
    is_visible: z.boolean(),
    instructions: z.string().nullable(),
    display_order: z.number(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
    formula: z.string().nullable(),
    default_ramp_duration_h: z.string().nullable(),
    line_type_id: fermentationLineTypeId.nullable(),
    entry_ordinal: z.number(),
});
export const fermentationProtocolParameterInitializer = z.object({
    id: fermentationProtocolParameterId.optional(),
    protocol_id: fermentationProtocolId,
    parameter_type_id: fermentationParameterTypeId,
    default_number_value: z.string().optional().nullable(),
    default_text_value: z.string().optional().nullable(),
    default_checkbox_value: z.boolean().optional().nullable(),
    is_required: z.boolean().optional(),
    is_visible: z.boolean().optional(),
    instructions: z.string().optional().nullable(),
    display_order: z.number().optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    formula: z.string().optional().nullable(),
    default_ramp_duration_h: z.string().optional().nullable(),
    line_type_id: fermentationLineTypeId.optional().nullable(),
    entry_ordinal: z.number().optional(),
});
export const fermentationProtocolParameterMutator = z.object({
    id: fermentationProtocolParameterId.optional(),
    protocol_id: fermentationProtocolId.optional(),
    parameter_type_id: fermentationParameterTypeId.optional(),
    default_number_value: z.string().optional().nullable(),
    default_text_value: z.string().optional().nullable(),
    default_checkbox_value: z.boolean().optional().nullable(),
    is_required: z.boolean().optional(),
    is_visible: z.boolean().optional(),
    instructions: z.string().optional().nullable(),
    display_order: z.number().optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    formula: z.string().optional().nullable(),
    default_ramp_duration_h: z.string().optional().nullable(),
    line_type_id: fermentationLineTypeId.optional().nullable(),
    entry_ordinal: z.number().optional(),
});
//# sourceMappingURL=FermentationProtocolParameter.js.map